import { logger } from "../../shared/logger";
import { build } from "./build";
import { types } from "./types";

export interface GenerateOptions {
  input: string;
  output: string;
  typesOutput: string;
  metaFilePath: string;
  overwrite: boolean;
  noTypes?: boolean;
}

export async function generate(options: GenerateOptions) {
  try {
    logger.block("⚙️  Building environment...");
    await build(options, {
      showPrefix: false,
      addSpace: "       ",
    });
    console.log();

    logger.block("⚙️  Generating types...");
    await types(
      {
        ...options,
        typesOutput: options.typesOutput,
      },
      {
        showPrefix: false,
        addSpace: "       ",
      }
    );
    console.log();

    logger.success("✅ Generation completed successfully.\n", {
      showPrefixIcon: false,
    });
  } catch (err) {
    logger.error(`Error during generation: ${err.message || err}`);
  }
}
